<template>
  <div
    id="agent-cancellation"
    class="div-flex-column-center"
    v-loading="loading"
  >
    <!-- 作废地址 -->
    <div class="search-line">
      <el-input
        v-model="searchData.orderNo"
        placeholder="订单编号"
        clearable
        @keyup.enter.native="resetPage"
      ></el-input>
      <el-input
        v-model="searchData.companyName"
        placeholder="企业名称"
        clearable
        @keyup.enter.native="resetPage"
      ></el-input>
      <el-select
        v-if="roleId == '1'"
        v-model="searchData.areaId"
        placeholder="区域名称"
        clearable
        @change="resetPage"
      >
        <el-option-group
          v-for="group in alreadyAreaSelectOption"
          :key="group.label"
          :label="group.label"
        >
          <el-option
            v-for="item in group.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-option-group>
      </el-select>
      <!-- <el-select
        v-model="searchData.areaFlag"
        placeholder="区域范围"
        clearable
        @change="resetPage"
      >
        <el-option label="安徽省" value="0"></el-option>
        <el-option label="合肥市" value="1"></el-option>
      </el-select> -->
      <el-date-picker
        v-model="searchData.gmtCreate"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="作废范围"
        end-placeholder="作废范围"
        @change="resetPage"
      >
      </el-date-picker>
    </div>
    <div class="content div-flex-center">
      <el-table :data="tableData" border style="width: 90%" height="98%">
        <el-table-column
          :prop="item.key"
          :label="item.title"
          :width="item.width"
          :fixed="item.key == 'orderNo' ? true : item.fixed"
          v-for="(item, index) in tableMenu"
          :key="index"
        >
          <template slot-scope="scope">
            <span>{{ scope.row[item.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <!-- @current-change="getAllCompanyList" -->
      <el-pagination
        @current-change="initData"
        :current-page.sync="pageData.currentPage"
        :page-size="pageData.pageSize"
        layout="total, prev, pager, next,jumper"
        :total="pageData.total"
      >
      </el-pagination>
    </div>
    <div id="my-dialog" class="div-flex-center" v-if="dialogData.flag">
      <div
        class="my-dialog-content div-flex-column-center"
        v-loading="dialogData.loading"
      >
        <div class="top div-flex-center">
          <div class="title">{{ dialogData.title }}</div>
          <div class="perch-active"></div>
          <div class="close">
            <i class="el-icon-close" @click="dialogData.flag = false"></i>
          </div>
        </div>
        <div
          class="content div-flex-column-center"
          v-if="dialogData.type == 'add'"
        ></div>
        <div class="buts div-flex-center">
          <div
            class="but"
            v-for="(item, index) in dialogData.buttonList"
            :key="index"
            @click="dialogHandleCilck(item.active)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as agentData from "../../assets/js/agentData.js";
export default {
  data() {
    return {
      input: "12312",
      roleId: "",
      loading: false,
      userData: {
        userId: "",
        userName: "",
        icon: "",
      },
      searchData: {
        orderNo: "",
        companyName: "",
        areaId: "",
        areaFlag: "",
        gmtCreate: [],
      },
      orderList: agentData.getAssignDialogData(),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },
      tableData: [],
      tableMenu: [
        {
          key: "orderNo",
          title: "订单编号",
          width: "200",
          fixed: false,
        },
        {
          key: "companyName",
          title: "企业名称",
          width: "300",
          fixed: false,
        },
        {
          key: "address",
          title: "作废地址",
          width: "350",
          fixed: false,
        },
        {
          key: "clusterAddress",
          title: "现有地址",
          width: "350",
          fixed: false,
        },
        {
          key: "invalidUserName",
          title: "作废人",
          width: "120",
          fixed: "right",
        },
        {
          key: "gmtCreate",
          title: "作废时间",
          width: "200",
          fixed: "right",
        },
      ],

      tableOper: [],
      dialogData: {
        flag: false,
        title: "客户基本信息录入",
        loading: true,
        type: "sign",
        baseData: {
          // 录入基本信息时,填写的表单信息
          title: "", // 自定义表单标题
          id: "", // 自定义表单ID
          time: "", // 时间
        },
        data: [],
        buttonList: [],
      },
      tempData: {},
      areaSelectOption: [],
      alreadyAreaSelectOption: [],
    };
  },
  methods: {
    /**
     * 2.3 获取当前角色权限
     */
    getUserAuthority() {
      this.$baseData.getUserAuthority(this.userData.userId, this, (data) => {
        this.roleId = data[0].roleId;
        this.tableOper = this.$baseData.judgeButtonPermissions(
          data[0].model,
          this.tableOper,
          "代理管理",
          "作废地址"
        );
        console.log("当前界面按钮权限:", this.tableOper);
        this.getAreaSelectOption();
      });
    },
    getAreaSelectOption() {
      this.$request(
        "get",
        "/area/getAreaSelectOption?flag=0", // 0 - 查询未代理；1 - 查询已代理；不传查询全部
        {},
        (data) => {
          this.areaSelectOption = data;
          this.$request(
            "get",
            "/area/getAreaSelectOption?flag=1", // 0 - 查询未代理；1 - 查询已代理；不传查询全部
            {},
            (data) => {
              this.alreadyAreaSelectOption = data;
              this.initData();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            }
          );
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        }
      );
    },
    // 列表数据
    initData() {
      let requestData = {
        userId: this.userData.userId, // 当前登录用户 不传搜索范围为总公司, 传搜索范围为区域审核下的地址
        orderNo: this.searchData.orderNo, // 筛选项：订单编号
        companyName: this.searchData.companyName, // 筛选项：公司名称
        areaId: this.searchData.areaId, // 筛选项：区域名称对应的区域 id
        gmtCreate: this.searchData.gmtCreate, // 筛选项：注册时间
        currentPage: this.pageData.currentPage,
        pageSize: this.pageData.pageSize,
      };
      if (this.roleId == "1") {
        requestData.userId = "";
      }
      this.$request(
        "post",
        "/addressInvalid/page",
        requestData,
        (data) => {
          this.tableData = data.records;
          this.pageData.total = data.total;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        }
      );
    },
    /**
     * 重置 page 请求列表数据
     */
    resetPage() {
      this.pageData.currentPage = 1;
      this.initData();
    },
    /**
     * 表格按钮操作事件
     */
    handleClick(item, active) {
      let requestData = {};
      this.tempData = item;
      switch (active) {
        default:
          break;
      }
    },
    /**
     * dialog 按钮操作事件
     */
    dialogHandleCilck(active) {
      let requestData = {};
      let flag = false;
      switch (active) {
        case "cancel":
          // 取消
          this.dialogData.flag = false;
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    let dd = {
      id: "",
      name: "作废地址",
      auth: "2",
      path: "/main/agent/agent_cancellation",
    };
    sessionStorage.setItem("childernMenu", JSON.stringify(dd));
    this.getUserAuthority();
  },
};
</script>

<style lang="less" scoped>
#agent-cancellation {
  width: 100%;
  height: 100%;
  .search-line {
    width: 100%;
    height: auto;
    min-height: 50px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    .el-input {
      width: 23% !important;
      margin-left: 10px !important;
      margin-top: 5px;
      .el-input__inner {
        height: 30px !important;
      }
    }
    .el-select,
    .el-range-editor {
      width: 23% !important;
      margin-left: 10px !important;
      margin-top: 5px;
    }
  }
  .content {
    width: 98%;
    height: 0;
    flex: 1;
    .tip {
      color: @baseColor;
      transition: 0.3s;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
        color: @activeColor;
      }
    }
  }
  .page {
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
  }
  .buts {
    width: 100%;
    height: 50px;
    .but {
      width: auto;
      height: auto;
      padding: 5px 15px;
      margin: 0 10px;
      box-sizing: border-box;
      border-radius: 8px;
      background-color: @baseColor;
      color: #ffffff;
      font-size: @font-size-tip-mini;
      transition: 0.3s;
      &:hover {
        cursor: pointer;
        background-color: @but-hoverColor;
      }
    }
  }
  #my-dialog .content {
    width: 98%;
    height: 0;
    flex: 1;
    .content-item {
      width: 33%;
      height: 50%;
      font-size: 14px;
      .content-item-top {
        width: 100%;
        height: 35px;
        position: relative;
        .content-item-top-line {
          width: 100%;
          height: 1px;
          background-color: rgba(160, 160, 160, 0.288);
          position: absolute;
          left: 0;
          top: 10px;
        }
        .content-item-top-title {
          width: auto;
          background-color: #ffffff;
          height: 100%;
          position: absolute;
          left: 30px;
          padding: 0 8px;
          font-size: 14px;
          span {
            color: red;
            margin-left: 8px;
          }
        }
      }
      .content {
        width: 98%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 13px;
        .line {
          width: 100%;
          height: 30px;
          display: flex;
          align-items: center;
          .span {
            width: auto;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 3px;
            box-sizing: border-box;
          }
          .value {
            width: 0;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
          }
        }
      }
    }

    .buts {
      width: 100%;
      height: 50px;
      .but {
        width: auto;
        height: auto;
        padding: 5px 15px;
        margin: 0 10px;
        box-sizing: border-box;
        border-radius: 8px;
        background-color: @baseColor;
        color: #ffffff;
        font-size: @font-size-tip-mini;
        transition: 0.3s;
        &:hover {
          cursor: pointer;
          background-color: @but-hoverColor;
        }
      }
    }
    .tip {
      margin-top: 20px;
      font-size: 14px;
    }
  }
}
</style>
